(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saege-complete-the-look"]) return;
  try {
    
(function () {

  /* ---------------------------------------------------------------
     MOBILE FULL BLEED, measured rather than guessed.

     Same job, same method, as the UGC strip in the buy column: pull the row
     out to both viewport edges so cards travel all the way out when swiped,
     while the first card still starts on the page's normal gutter.

     THE OFFSET IS PADDING, NOT POSITION - this is the part that caught me
     out. margin-left: calc(50% - 50vw) assumes the container is centred in
     the viewport; when that was tried on this page it stretched it to 2232px
     against a 1709px viewport and created horizontal page scroll. So the
     distance is measured instead. But .saege-ctl__inner is a full-width
     .container whose left edge sits at x=0: the 16px gutter is its PADDING,
     inside the box. Measuring getBoundingClientRect().left alone returns 0
     and the bleed silently collapses. The real distance from the viewport
     edge to the first card is the element's offset PLUS its padding, which
     is what is summed below.

     .saege-ctl__inner is measured rather than .product-list because the
     inner never receives the negative margins - measuring the element the
     result is applied to would read zero on every call after the first.

     Clamped to 64px, and the stylesheet defaults both to 0px, so a failure
     here costs the bleed and nothing else - never a page that scrolls
     sideways.
     --------------------------------------------------------------- */
  var MAX_BLEED = 64;

  function clamp(n) {
    if (!isFinite(n) || n < 0) return 0;
    return n > MAX_BLEED ? MAX_BLEED : Math.round(n);
  }

  function bleed(root) {
    var inner = root.querySelector('.saege-ctl__inner');
    if (!inner) return;

    inner.style.removeProperty('--saege-bleed-l');
    inner.style.removeProperty('--saege-bleed-r');
    if (window.innerWidth >= 768) return;

    var r = inner.getBoundingClientRect();
    var cs = window.getComputedStyle(inner);
    var l = clamp(r.left + (parseFloat(cs.paddingLeft) || 0));
    var rt = clamp((window.innerWidth - r.right) + (parseFloat(cs.paddingRight) || 0));

    inner.style.setProperty('--saege-bleed-l', l + 'px');
    inner.style.setProperty('--saege-bleed-r', rt + 'px');
  }

  /* ---------------------------------------------------------------
     HOVER IMAGES.

     The card hover swaps to the product's second photo. It was fading to a
     blank white box instead, and the reason is worth writing down.

     snippets/product-block.liquid does not render the second photo as an
     <img>. It renders a stack of divs carrying data-lazy-bgset-src, which
     the theme converts into real background images during its own init.
     This section's markup arrives AFTER that init - it is fetched from the
     recommendations route and swapped in - so the conversion never runs on
     it. theme.ProductBlockManager.loadImages() flips the lazyload--manual
     class but does not do the data-lazy-bgset-src to background-image step,
     so the layers stay empty. The container still carries
     image-cont--with-secondary-image, so the CSS dutifully fades the real
     photo out to reveal nothing.

     So the background is set here directly. Two rules about it:

       - ONLY the hover layer is loaded up front. The other layers behind it
         belong to the card's swipe-through dots; loading all of them would
         be about 50 extra image requests on a page that has a product
         gallery of its own to get through first. They load on first
         interaction with that card instead.

       - The card is not marked saege-hover-ready until the image has
         actually decoded. Until then the CSS holds the primary photo
         visible, so a hover during that window shows the product rather
         than the white box this is here to fix. Painting a background is
         not the same as having the pixels.
     --------------------------------------------------------------- */
  function imageWidth(block) {
    var w = Math.round(block.getBoundingClientRect().width * (window.devicePixelRatio || 1));
    if (!w) w = 400;
    return Math.min(Math.max(w, 300), 1200);
  }

  function paint(layer, width, onDone) {
    var src = layer.getAttribute('data-lazy-bgset-src');
    if (!src || layer.getAttribute('data-saege-bg')) { if (onDone) onDone(); return; }
    layer.setAttribute('data-saege-bg', '1');
    var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    var probe = new Image();
    probe.onload = probe.onerror = function () {
      layer.style.backgroundImage = 'url("' + url + '")';
      layer.classList.add('lazyloaded');
      layer.classList.remove('lazyload', 'lazyload--manual');
      if (onDone) onDone();
    };
    probe.src = url;
  }

  function hoverImages(root) {
    [].slice.call(root.querySelectorAll('.product-block')).forEach(function (block) {
      var width = imageWidth(block);
      var hover = block.querySelector('.product-block__image--show-on-hover [data-lazy-bgset-src]');

      if (!hover) {
        block.classList.add('saege-hover-ready');
      } else {
        paint(hover, width, function () { block.classList.add('saege-hover-ready'); });
      }

      var rest = function () {
        [].slice.call(block.querySelectorAll('.product-block__image--secondary [data-lazy-bgset-src]'))
          .forEach(function (layer) { paint(layer, width); });
        block.removeEventListener('mouseenter', rest);
        block.removeEventListener('touchstart', rest);
      };
      block.addEventListener('mouseenter', rest);
      block.addEventListener('touchstart', rest, { passive: true });
    });
  }

  /* ---------------------------------------------------------------
     Scroll controls. The bar is a POSITION indicator - the thumb is sized to
     the share of the row on screen and moves with it. The arrows exist
     because a mouse cannot scroll a row sideways and the native scrollbar is
     hidden; they are shown only for fine pointers, only when the row
     overflows, and each disables at its end.
     --------------------------------------------------------------- */
  function controls(root) {
    var list = root.querySelector('.product-list');
    if (!list || !list.parentNode) return;

    var host = list.parentNode;
    var old = host.querySelector('.saege-ctl__scrollbar');
    if (old) old.remove();

    var track = document.createElement('div');
    track.className = 'saege-ctl__scrollbar';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'saege-ctl__scrollbar-thumb';
    track.appendChild(thumb);
    host.appendChild(track);

    var nav = root.querySelector('.saege-ctl__nav');
    var arrows = nav ? [].slice.call(nav.querySelectorAll('.saege-ctl__arrow')) : [];
    var finePointer = !window.matchMedia || window.matchMedia('(pointer: fine)').matches;

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-saege-dir'), 10) || 1;
        list.scrollBy({ left: dir * Math.round(list.clientWidth * 0.8), behavior: 'smooth' });
      });
    });

    var queued = false;
    function sync() {
      queued = false;
      var span = list.scrollWidth - list.clientWidth;
      if (span <= 4 || !list.scrollWidth) {
        track.classList.remove('is-active');
        if (nav) nav.hidden = true;
        return;
      }
      track.classList.add('is-active');
      if (nav) nav.hidden = !finePointer;

      var ratio = list.clientWidth / list.scrollWidth;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.transform = 'translateX(' + ((list.scrollLeft / span) * ((100 / ratio) - 100)) + '%)';

      arrows.forEach(function (btn) {
        var dir = parseInt(btn.getAttribute('data-saege-dir'), 10) || 1;
        btn.disabled = dir < 0 ? list.scrollLeft <= 1 : list.scrollLeft >= span - 1;
      });
    }
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }

    list.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('orientationchange', queue);
    if (window.ResizeObserver) {
      try { new ResizeObserver(queue).observe(list); } catch (e) {}
    }
    sync();
    setTimeout(sync, 600);
  }

  function load() {
    var el = document.querySelector('.saege-ctl');
    if (!el || !el.dataset.url || el.dataset.saegeLoaded) return;
    el.dataset.saegeLoaded = '1';
    var req = new XMLHttpRequest();
    req.open('GET', el.dataset.url);
    req.onload = function () {
      if (req.status < 200 || req.status >= 300) return;
      var box = document.createElement('div');
      box.innerHTML = req.response;
      var fresh = box.querySelector('.saege-ctl');
      if (!fresh) return;
      el.innerHTML = fresh.innerHTML;
      /* theme.js can be late - the head script-deferring hack delays several
         third-party scripts and has bitten this page before, so never assume
         the theme namespace is there */
      try {
        if (window.theme && theme.ProductBlockManager) theme.ProductBlockManager.loadImages(el);
        if (window.theme && theme.initAnimateOnScroll) theme.initAnimateOnScroll();
      } catch (e) {}
      bleed(el);
      hoverImages(el);
      controls(el);

      var bt;
      function rebleed() { clearTimeout(bt); bt = setTimeout(function () { bleed(el); }, 120); }
      window.addEventListener('resize', rebleed);
      window.addEventListener('orientationchange', rebleed);
    };
    req.send();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = document.querySelector('[data-section-id="' + e.detail.sectionId + '"].saege-ctl');
    if (el) { delete el.dataset.saegeLoaded; load(); }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
